import { put, logError } from "shared/lib/api"

// IFE rejected the submitted values (the controller relays it as a 422);
// this is a user-data problem, not a fault worth reporting to Sentry.
const isValidationError = (error: { status?: number | string }) =>
  error.status === 422

export default function saveStencils(
  endpoint: string,
  payload: object
): Promise<void> {
  return put(endpoint, payload)
    .then(() => {
      window.appendFlash("Applet template saved", "success")
    })
    .catch((error: { status?: number | string }) => {
      if (isValidationError(error)) {
        window.appendFlash(
          "Could not save this Applet template. Please check your data.",
          "danger"
        )
      } else {
        logError(() => {
          window.appendFlash("Failed to save. Try again!", "danger")
        })(error)
      }
    })
}
